<mat-card align="center">
    {{'keyword_$408' | translate}}
</mat-card>
